import React, { useEffect, useState } from 'react'
import System from 'src/helper/system';
import { useCartStore } from 'src/hooks/cart';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import { useOrderStore } from 'src/hooks/order';
import { profileStore } from 'src/hooks/profile';
import useReduxState from 'src/hooks/useReduxState';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import Constants from 'src/helper/Constants';
import Helper from 'src/helper/Helper';
import { __set, __remove } from "src/store/axios_indicator";
import { Beacon } from 'src/component/Global/Beacon';
import {stepEventMaker} from "src/support/stepEventMaker";
import { useSelector } from "react-redux";
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';


const CheckoutShipping = () => {
    const [__check] = useAxiosIndicatorCheck();
    const [addShippingAddress, setAddShippingAddress] = useState(false);
    const {
        siteUser,
        addressType,
        mobilePattern,
        emailPattern,
        paymentError,
        INVALIDMANUFACTURER,
        PreferenceType: { Default_ShipTo },
        shippingAddressType: { Type: { DOMESTIC } },
        checkOutSteps: { ADDRESS_STEP, METHOD_STEP }, taxExempt: { EXEMPT, NONE, OVERWRITE }, Restricted_Countries } = Constants
    const { storageName: { PAYMENT_ERROR }, avUserInfoData: { currentUser, salesOrg, accountNumber } } = System
    const isCoreUser = currentUser === siteUser.CORE
    const [isEdit, setIsEdit] = useState(false);
    const [errors, setErrors] = useState({});
    const [shippingAddressInfo, setShippingAddressInfo] = useReduxState({}, 'setShippingAddressInfo')
    const [shippingMethodInfo, setShippingMethodInfo] = useReduxState({}, 'setShippingMethodInfo')
    const [checkOutStepStatus, setCheckoutStepStatus] = useReduxState(ADDRESS_STEP, 'setCheckoutStepStatus')
    const [exportComplianceStatus, setExportComplianceStatus] = useReduxState(false, 'setExportComplianceStatus')
    const [complianceValue, setComplianceValue] = useReduxState('', 'setComplianceValue')
    const [{ shipping_addresses, billing_addresses }, { get_profile_account_information, fetch_all_carrier_data }, { set_account_address_default }] = profileStore();
    const [{ }, { system_alert_indicator, remove_system_alert_indicator }, { }] = useDOMAttachToSystemStore();
    const [{ CART_DATA, WEB_ORDER_ID, CART_PRODUCTS }, { }, { }] = useCartStore();
    const [{ validate_order_from_server }, { get_validate_order_from_server, fetch_place_order_items }, { place_your_order }] = useOrderStore();
    const [shipOnlyWhenAvailable, setShipOnlyWhenAvailable] = useReduxState(false, "setShipOnlyWhenAvailable");
    const [taxExemptDetails, setTaxExemptDetails] = useReduxState({ taxExemptFile: '', taxExempt: NONE }, "setTaxExemptDetails");

    const [{ }, { get_inventory_by_id }, { }] = useProductInventoryPriceStore();
    const [isErrorInStep1, setIsErrorInStep1] = useState(false);
    const [initialOrderFetch, setInitialOrderFetch] = useState(true)
    const [prevShippingData, setPrevShippingData] = useReduxState('', 'setPrevShippingData')
    const isContainSoftwareParts = CART_PRODUCTS && Object.values(CART_PRODUCTS).some(f => f.SoftwareDownloadFlag === true);
    const isOnlySoftwareParts = CART_PRODUCTS && !Object.values(CART_PRODUCTS).some(f => f.SoftwareDownloadFlag === false);
    /**
    None : 0
    Exempt : 1
    Overwrite : 2
    */

    useEffect(() => {
        async function fetchHere() {
            const detail = await fetch_place_order_items(WEB_ORDER_ID);
            if (detail && Object.entries(detail.payload).length > 0) {
                let shippingAddressData = {
                    attn: detail.payload?.attn || '',
                    telephoneNumber: detail.payload?.telephoneNumber || '',
                    SoftwareDownloadEmail: detail.payload?.softwareDownloadEmail || '',
                    ...shipping_addresses.find((shipAdd) => shipAdd.id === detail.payload?.shipToId)
                }
                setShippingAddressInfo({ ...shippingAddressData })
                setShipOnlyWhenAvailable(detail.payload?.shippingPreference)
                setTaxExemptDetails({ taxExempt: detail.payload?.taxExempt === 0 ? NONE : (detail.payload?.taxExempt === 1 ? EXEMPT : OVERWRITE), taxExemptFile: detail.payload?.taxExemptFileName })
                setInitialOrderFetch(false)

                validateHazardousItemInCart();

            }
        }

        if ((!shippingAddressInfo?.id || initialOrderFetch) && shipping_addresses?.length > 0 && !__check(['VIEW_CART_API_CALL']).status) {
            if (WEB_ORDER_ID) {
                fetchHere();
            } else {
                const address = isCoreUser
                    ? System.getUserAddressType(shipping_addresses, shippingAddressInfo?.id)?.shippingAddressValue
                    : shipping_addresses[0];
                setShippingAddressInfo(address);
            }
        }

    }, [WEB_ORDER_ID, __check(['VIEW_CART_API_CALL']).status, shipping_addresses]);


    useEffect(() => {
        const fetchHere = async () => {
            __set('VALIDATE_ORDER_API_CALL');
            await get_validate_order_from_server({ shipToAddressId: shippingAddressInfo.id })
            __remove('VALIDATE_ORDER_API_CALL');
        }
        if (shippingAddressInfo?.id) {
            fetchHere()
        }
    }, [shippingAddressInfo?.id])

    useEffect(() => {
        validateHazardousItemInCart()
    }, [CART_DATA])

    useEffect(() => {
        if (new URL(window.location.href)?.searchParams.has(paymentError)) {
            system_alert_indicator({
                name: 'placeOrderError',
                message: localStorage.getItem(PAYMENT_ERROR),
                type: "danger",
                isDisplay: false,
                isDisplayIcon: true
            })
        } else {
            localStorage.removeItem(PAYMENT_ERROR)
        }
    }, [])


    const validateHazardousItemInCart = () => {
        if (CART_PRODUCTS && Object.values(CART_PRODUCTS)?.length > 0) {
            const ishazardious = Object.values(CART_PRODUCTS).find(f => f.HazardousFlag === true)
            if (ishazardious) {
                system_alert_indicator({
                    name: 'HazardousFlag',
                    message: "Hazardous Item: Due to restrictions on the transportation of dangerous/hazardous goods, there may be additional transit time on this item. Delivery of other items on your order will be unaffected.",
                    type: "warning",
                    isDisplay: false,
                    isDisplayIcon: true
                });
            }
        }
    }
    const validateShippingAddress = async () => {
        let userrAddressType = System.getUserAddressType(shipping_addresses, shippingAddressInfo?.id)?.shippingType;

        let validationErrors = {};
        await remove_system_alert_indicator("PoBoxAlertForGroundShipping");

        await remove_system_alert_indicator("shipToPOBox");
        await remove_system_alert_indicator("flipDistributor");
        await remove_system_alert_indicator(INVALIDMANUFACTURER);
        await remove_system_alert_indicator(Constants.INVALIDSUPPLIER);
        if (validate_order_from_server && Object.keys(validate_order_from_server).length > 0) {
            Object.entries(validate_order_from_server.validation || {}).forEach(([name, message]) => {
                system_alert_indicator({
                    name,
                    message,
                    type: "danger",
                    isDisplay: false,
                    isDisplayIcon: true,
                    data: name === Constants.INVALIDSUPPLIER ? validate_order_from_server?.cartItems?.filter(ele => ele?.isSupplierRestricted === true).map(ele => ele?.erpMfrPartNumber) : null,
                });

                validationErrors[name] = message;
            });
        }

        if (CART_PRODUCTS && Object.values(CART_PRODUCTS)?.length > 0) {
            const ishazardious = Object.values(CART_PRODUCTS).find(f => f.HazardousFlag === true)
            if (ishazardious && userrAddressType !== DOMESTIC) {
                system_alert_indicator({
                    name: 'PoBoxAlertForGroundShipping',
                    message: "Due to hazardous material, only ground shipping is available within North America. Please remove any items that contain hazardous material (e.g., batteries) from your cart or change your shipping address to a US address to proceed to checkout.",
                    type: "danger",
                    isDisplay: false,
                    isDisplayIcon: true,
                });

                validationErrors.PoBoxAlertForGroundShipping = "invalid userrAddressType";
            }
        }
        return Object.keys(validationErrors).length === 0;
    }

    useEffect(() => {
        async function fetchHere() {
            await get_profile_account_information();
        }
        fetchHere()
    }, [])

    const changeShipAddress = (address) => {
        if (address) {
            setShippingAddressInfo({ ...shippingAddressInfo, ...address })
            setIsErrorInStep1(false)
        } else {
            setAddShippingAddress(true)
            setExportComplianceStatus(false)
            setComplianceValue("")
            setInitialOrderFetch(false)
        }
        setShippingMethodInfo({})
    };
    const onValidateData = () => {
        let validationModal = {};
        if (isContainSoftwareParts) {
            if (!shippingAddressInfo.attn) {
                validationModal.attn = "A valid name is required.";
            }
            if (!mobilePattern.test(shippingAddressInfo.telephoneNumber)) {
                validationModal.telephoneNumber = "A valid phone number is required.";
            }
            if (!emailPattern.test(shippingAddressInfo.SoftwareDownloadEmail)) {
                validationModal.SoftwareDownloadEmail = "A valid Email Address is required.";
            }
        } else {
            if (shippingAddressInfo?.telephoneNumber && !mobilePattern.test(shippingAddressInfo.telephoneNumber)) {
                validationModal.telephoneNumber = "A valid phone number is required.";
            }
        }
        setErrors(validationModal);
        return Object.keys(validationModal).length === 0;
    };

    const onSubmit = async () => {
        let isValidShippingAddress = await validateShippingAddress();
        if (isValidShippingAddress == false) {
            setIsErrorInStep1(true);
        } else {
            setIsErrorInStep1(false);
        }
        let isValid = await onValidateData();
        if (isValid && isValidShippingAddress) {
            setAddShippingAddress(false)
            if (initialOrderFetch) {
                setInitialOrderFetch(false)
            }

            if (prevShippingData !== shippingAddressInfo?.id) {
                setExportComplianceStatus(false)
                setComplianceValue("")
            }

            let params = {
                billTo: billing_addresses[0]?.id || null,
                shipToId: shippingAddressInfo && shippingAddressInfo?.id ? shippingAddressInfo.id : '',
                attn: shippingAddressInfo?.attn?.trim() ? shippingAddressInfo?.attn?.trim() : '',
                telephoneNumber: shippingAddressInfo?.telephoneNumber?.trim() ? shippingAddressInfo?.telephoneNumber?.trim() : '',
                SoftwareDownloadEmail: shippingAddressInfo?.SoftwareDownloadEmail?.trim() ? shippingAddressInfo?.SoftwareDownloadEmail?.trim() : null,
                orderPlaced: false,
                taxExempt: taxExemptDetails?.taxExempt
            }

            setPrevShippingData(shippingAddressInfo?.id)
            __set("PLACE_ORDER_API_CALL");
            let res = await place_your_order(params)
            __remove("PLACE_ORDER_API_CALL");
            if (res?.webOrderNumber) {
                setIsEdit(true);
                //fetch carrier options
                if (!isOnlySoftwareParts) {
                    __set('CARRIER_OPTION_UPDATE');
                    await fetch_all_carrier_data({ orderId: res?.webOrderNumber, country: shippingAddressInfo?.address?.countryName?.trim(), shipToId: shippingAddressInfo?.id });
                    __remove('CARRIER_OPTION_UPDATE');
                }
                setCheckoutStepStatus(METHOD_STEP)
                checkOutStep1();
            } else {
                system_alert_indicator({
                    name: 'placeOrderError',
                    message: res?.Message || 'Order Submission failed. Please try again later.',
                    type: "danger",
                    isDisplay: false,
                    isDisplayIcon: true
                })
            }
        }
    }

    const setDefaultAddress = async (address, preferenceFilter = "") => {
        const data = {
            preferenceType: Default_ShipTo,
            preferenceValue: address?.id,
            preferenceFilter: preferenceFilter
        }
        __set('SET_DEFAULT_SHIPPING_ADDRESS_API_CALL');
        const res = await set_account_address_default(data);
        if (res) {
            await get_profile_account_information();
            changeShipAddress(address)
        }
        __remove('SET_DEFAULT_SHIPPING_ADDRESS_API_CALL');
    }
    const openAddShippingPopup = (addressInfo) => {
        System.popup('ProfileAddressPopup', addressInfo);
    }

     //By Ramya Kannan [Cart, quote Checkout-step1 ] 
     let quoteDetails = useSelector(
         (state) => state.entities.model_QuoteDetail.cart_quote_active_session
       );

    const c = System.getParams();
    const quoteNumber = c.quote_number;
     function checkOutStep1(){
         localStorage.setItem("adobeEventType","checkOut");
         let checkOutStep = "checkoutStep1";
         let cartData = [];
         Object.entries(CART_DATA).map((data,key)=>{
            cartData.push(data[1])
         })
         cartData.forEach((data,key)=>{
            let copyObj = {...data};
            copyObj.qas = get_inventory_by_id(copyObj.ItemNumber || copyObj.itemNumber)?.inventoryQty || copyObj.quantity;
            cartData[key] = copyObj;
          })
         stepEventMaker(cartData,quoteDetails,checkOutStep,quoteNumber);
     }
    return (
        <div className={`shipping-address steps-inner mb-3 active ${isEdit ? ' completed' : ''}`}>
            <div className="checkout-titles d-flex justify-content-between"><h2>1. Shipping Address </h2> {isEdit && <a className='text-white' onClick={() => {
                setIsEdit(false);
                remove_system_alert_indicator('carrierOptionAlert');
                setCheckoutStepStatus(ADDRESS_STEP)
            }} >Change </a>}</div>
            <div className='shipping-address-detail checkbox-steps-content pt-0 pb-0'>
                <div className='bs5 row'>
                    <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pt-2 pb-2'>
                        <div style={!addShippingAddress ? { display: "block" } : { display: "none" }}>

                            <div className='d-flex justify-content-between'>
                                {shippingAddressInfo?.address && <div>
                                    <div className="font-16 font-bold font-apecru mb-2">{shippingAddressInfo?.companyName} </div>
                                    <p> {shippingAddressInfo?.address?.addressLineOne},<br /> {Helper.valueIsNotNull(shippingAddressInfo?.address?.addressLineTwo) ? <>{shippingAddressInfo?.address?.addressLineTwo + ","}<br /></> : ""}{shippingAddressInfo?.address?.cityName}, {Helper.valueIsNotNull(shippingAddressInfo?.address?.stateName) ? shippingAddressInfo?.address?.stateName + " " : ""} {shippingAddressInfo?.address?.postalCode}, <br /> {shippingAddressInfo?.address?.countryName}.</p>
                                </div>}
                                {isCoreUser && <span className='text-start'><b>Shipping Account No.</b><p>{shippingAddressInfo?.id}</p> </span>}
                            </div>
                            {!isCoreUser && !isEdit && <div className="shipping-option step-complete-hide position-relative" onClick={() => !isEdit ? changeShipAddress() : ''} >
                                <Beacon position={"right"} content={() => "Click here to add a new address or to edit/delete default address."}
                                    opener={() => (
                                        <div className="becon-dot"></div>
                                    )} />
                                <a className="text-blue2 me-1">Add/Change Shipping Address</a>
                            </div>}
                        </div>
                        <div className='choose-address' style={addShippingAddress ? { display: "block" } : { display: "none" }}>
                            <div className='font-arial font-16 text-uppercase'><b>Choose Address:</b></div>
                            <a onClick={() => openAddShippingPopup({ 'type': addressType.SHIP_TO, 'addressInfo': {} })} className='addnewaddress'> <i className="fa fa-plus me-2" aria-hidden="true"></i>
                                ADD A NEW ADDRESS</a>

                            <div className='choose-address-list'>
                                {shipping_addresses?.length > 0 && <div>
                                    <div className='font-arial font-13 text-uppercase mb-2'><b> <u>Address</u></b></div>

                                    {shipping_addresses.map((shipadd, index) => (<div key={index} className='choose-address-box'>
                                        <input className="form-check-input" type="radio" name="radioNoLabel" id={`radioNoLabel${index}`} checked={shippingAddressInfo.id == shipadd.id || (shipping_addresses?.length === 1 && true)} value="" aria-label="..." disabled={Restricted_Countries.includes(shipadd?.address.countryCode)} onChange={() => changeShipAddress(shipadd)} />
                                        <div className='font-arial font-13'>
                                            <label htmlFor={`radioNoLabel${index}`} className="cursor-pointer">
                                                <strong>{shipadd?.companyName}</strong>
                                                <p className='font-arial font-13'>
                                                    {shipadd?.address.addressLineOne},<br /> {Helper.valueIsNotNull(shipadd?.address.addressLineTwo) ? <> {shipadd?.address.addressLineTwo + ","}<br /></> : ""} {shipadd?.address.cityName}, {Helper.valueIsNotNull(shipadd?.address.stateName) ? shipadd?.address.stateName + " " : ""} {shipadd?.address.postalCode}, <br /> {shipadd?.address.countryName}.
                                                </p>
                                            </label>
                                            <p className='font-arial font-12 pb-2'>
                                                {shipping_addresses?.length == 1 || shipadd?.default ? <strong> Default</strong> : <a onClick={async () => setDefaultAddress(shipadd, (isCoreUser ? (salesOrg + "-" + accountNumber) : ""))}>Set To Default</a>}
                                            </p>
                                        </div>
                                    </div>))}
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                        <div className='shipping-additional-info step-complete-hide info-text'>
                            <div className='form'>
                                <div className='mb-2'>Information used in case of order or shipping issues.</div>
                                <div className="mb-3">
                                    <label htmlFor="attn" className="form-label">ATTN{isContainSoftwareParts ? "*" : ""}</label>

                                    <input
                                        type="text"
                                        disabled={isEdit}
                                        className={`form-control ${errors.attn ? 'error' : ''}`}
                                        id="attn"
                                        placeholder="Attention"
                                        value={shippingAddressInfo?.attn || ''}
                                        maxLength={35}
                                        onChange={({ target: { value } }) => {
                                            const allowedPattern = /^[A-Za-z0-9\u00C0-\u017F d+\/&*#'_\-,\.()]*$/;
                                            const filteredValue = value.split('').filter(char => allowedPattern.test(char)).join('');
                                            setShippingAddressInfo({ ...shippingAddressInfo, attn: filteredValue });
                                        }}
                                    />
                                    {errors.attn && <p className="error">{errors.attn}</p>}
                                </div>
                                <div className="mb-3"><label htmlFor="ph-no" className="form-label">Phone Number{isContainSoftwareParts ? "*" : ""}</label>

                                    <input
                                        type="text"
                                        disabled={isEdit}
                                        className={`form-control ${errors.telephoneNumber ? 'error' : ''}`}
                                        id="phone"
                                        placeholder="Phone number"
                                        value={shippingAddressInfo?.telephoneNumber || ''}
                                        onChange={({ target: { value } }) => setShippingAddressInfo({ ...shippingAddressInfo, telephoneNumber: value })}
                                        maxLength={32}
                                    />
                                    {errors.telephoneNumber && <p className="error">{errors.telephoneNumber}</p>}</div>
                                {isContainSoftwareParts && <div className="mb-3"><label htmlFor="email" className="form-label">Email Address for Downloadable Products*</label>

                                    <input
                                        type="text"
                                        disabled={isEdit}
                                        className={`form-control ${errors.SoftwareDownloadEmail ? 'error' : ''}`}
                                        id="email"
                                        placeholder="Email Address for Downloadable Products"
                                        value={shippingAddressInfo?.SoftwareDownloadEmail || ''}
                                        onChange={({ target: { value } }) => {
                                            const allowedChars = /^[A-Za-z\u00C0-\u017F0-9_\-@\.]*$/;
                                            const filteredValue = value.split('').filter(char => allowedChars.test(char)).join('');
                                            setShippingAddressInfo({...shippingAddressInfo,SoftwareDownloadEmail: filteredValue});
                                        }}
                                        maxLength={254}
                                    />
                                    {errors.SoftwareDownloadEmail && <p className="error">{errors.SoftwareDownloadEmail}</p>}</div>}
                            </div>
                        </div>

                        {(shippingAddressInfo?.attn || shippingAddressInfo?.telephoneNumber || shippingAddressInfo?.SoftwareDownloadEmail) && <div className="step-complete-show h-100">
                            <div className="info-text h-100">
                                {shippingAddressInfo?.attn && <p className="mb-2">ATTN: {shippingAddressInfo?.attn}</p>}
                                {shippingAddressInfo?.telephoneNumber && <p className="mb-2">Phone Number: {shippingAddressInfo?.telephoneNumber}</p>}
                                {isContainSoftwareParts && shippingAddressInfo?.SoftwareDownloadEmail && <p className="mb-2">Email Address for Downloadable Products: {shippingAddressInfo?.SoftwareDownloadEmail}</p>}
                            </div>
                        </div>}
                    </div>
                </div>
                <hr className="mb-0 mt-0 step-complete-hide"></hr>
            </div>
            <div className='shipping-method-detail checkbox-steps-content pt-0 step-complete-hide'>
                <div className='bs5 row'>
                    <div className='col-12 col-sm-12 col-lg-6 col-xl-6'>

                    </div>

                    <div className='col-12 col-sm-12 col-lg-6 col-xl-6 d-flex align-items-start flex-wrap'>
                        {!isEdit && <button type="button" className="bs5 btn btn-primary btn-sm mt-3 d-block ms-auto w100" disabled={!shippingAddressInfo?.id || isErrorInStep1 == true || Restricted_Countries.includes(shippingAddressInfo?.address?.countryCode)} onClick={() => onSubmit()} form="hook-form">Continue</button>}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CheckoutShipping;